import { render } from "./IpOSPrestadorDash.vue?vue&type=template&id=665cb6fc"
import script from "./IpOSPrestadorDash.vue?vue&type=script&lang=js"
export * from "./IpOSPrestadorDash.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__